<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useSchoolStore} from "@/stores/Training/School";
import axios from "axios";

export default {
    name: "StrSchoolAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const schoolStore = useSchoolStore();

        const school = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/schools`).then(response => {
                schoolStore.setSchools(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            school.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            schoolStore,
            loading,
            inputColor,
            backgroundColor,
            school,
            input,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
                v-model="school"
                :items="schoolStore.schools"
                item-value="id"
                item-text="name"
                outlined
                dense
                :chips="multiple"
                :deletable-chips="!readonly"
                :label="label"
                :color="inputColor"
                :background-color="backgroundColor"
                :readonly="readonly"
                :multiple="multiple"
                :loading="loading"
                :clearable="!readonly"
                @input="input"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>